import React, { useEffect, useState } from "react";

import purchaseOrderService from "./services/purchaseOrderService";
import {
  formatDate,
  formatQuantity
} from "../../../../../utils/formatUtils";

import POViewDrawer from "./POViewDrawer";
import POCreateDrawer from "./POCreateDrawer";
import POFromRFQDrawer from "./POFromRFQDrawer";

const POList = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const [selectedPO, setSelectedPO] = useState(null);

  const [showView, setShowView] = useState(false);
  const [showCreate, setShowCreate] = useState(false);
  const [showFromRFQ, setShowFromRFQ] = useState(false);

  // NEW STATE FOR EDIT MODE (ADDED – EXISTING STATES UNTOUCHED)
  const [showEdit, setShowEdit] = useState(false);

  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
const [pageSize, setPageSize] = useState(20);
  const loadData = async () => {
    try {
      setLoading(true);
      const res = await purchaseOrderService.getPOList();

      if (res.success) {
        setRows(res.data || []);
      }
    } catch (err) {
      alert(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  const summary = {
    total: rows.length,
    draft: rows.filter((r) => r.status_code === "DRAFT").length,
    approved: rows.filter((r) => r.status_code === "APPROVED").length,
    sent: rows.filter((r) => r.status_code === "SENT").length,
    closed: rows.filter((r) => r.status_code === "CLOSED").length,
  };

  const filtered = rows.filter((r) =>
    r.po_no?.toLowerCase().includes(search.toLowerCase())
  );
  const totalPages = Math.ceil(
  filtered.length / pageSize
);

const paginatedRows = filtered.slice(
  (currentPage - 1) * pageSize,
  currentPage * pageSize
);

const pageNumbers = Array.from(
  { length: totalPages },
  (_, i) => i + 1
);

  return (
    <div>

      {/* HEADER */}
      <div
        style={{
          background:
            "linear-gradient(90deg, #0f766e 0%, #14b8a6 50%, #5eead4 100%)",
          borderRadius: 12,
          padding: "16px 20px",
          color: "#fff",
          marginBottom: 20,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div>
          <h4 style={{ margin: 0 }}>
            Purchase Order Management
          </h4>
          <div style={{ fontSize: 13, opacity: 0.9 }}>
            External vendor purchase authorization
          </div>
        </div>

        <div>
          <button
            className="btn btn-light me-2"
            onClick={() => setShowCreate(true)}
          >
            + Create Direct PO
          </button>

          <button
            className="btn btn-light"
            onClick={() => setShowFromRFQ(true)}
          >
            + Create from RFQ
          </button>
        </div>
      </div>

      {/* KPI BAR */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(5, 1fr)",
          gap: 10,
          marginBottom: 20,
        }}
      >
        {[
          { label: "Total", value: summary.total },
          { label: "Draft", value: summary.draft },
          { label: "Approved", value: summary.approved },
          { label: "Sent", value: summary.sent },
          { label: "Closed", value: summary.closed },
        ].map((c, i) => (
          <div
            key={i}
            style={{
              background: "#fff",
              padding: 15,
              borderRadius: 8,
              borderLeft: "4px solid #14b8a6",
            }}
          >
            <div>{c.label}</div>
            <h5>{c.value}</h5>
          </div>
        ))}
      </div>

      {/* FILTER BAR */}
      <div
        style={{
          display: "flex",
          gap: 10,
          marginBottom: 15,
          background: "#f3f4f6",
          padding: 10,
          borderRadius: 8,
        }}
      >
        <input
          className="form-control"
          placeholder="Search PO no..."
          value={search}
          onChange={(e) => {
  setSearch(e.target.value);
  setCurrentPage(1);
}}
        />

        <button className="btn btn-primary" onClick={loadData}>
          Search
        </button>
      </div>

      {/* TABLE */}
      <div className="card">
        <div className="card-body p-0">
          <table className="table table-bordered mb-0">
            <thead className="table-light">
              <tr>
                <th>PO No</th>
                <th>Date</th>
                <th>Vendor</th>
                <th>Purpose</th>
                <th>Amount</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {loading && (
                <tr>
                  <td colSpan="7" className="text-center">
                    Loading...
                  </td>
                </tr>
              )}

              {!loading && filtered.length === 0 && (
                <tr>
                  <td colSpan="7" className="text-center text-muted">
                    No records found
                  </td>
                </tr>
              )}

              {!loading &&
                paginatedRows.map((r) => (
                  <tr key={r.id}>
                    <td>{r.po_no}</td>
                    <td>{formatDate(r.po_date)}</td>
                    
                    <td>{r.vendor_name || r.vendor_id}</td>
                    <td>{r.procurement_purpose || "-"}</td>
                    <td>{formatQuantity(r.net_amount)}</td>

                    <td>
                      <span className="badge bg-info">
                        {r.status_code}
                      </span>
                    </td>

                    <td>
                      <button
                        className="btn btn-sm btn-link"
                        onClick={() => {
                          setSelectedPO(r.id);
                          setShowView(true);
                        }}
                      >
                        View
                      </button>

                      {/* NEW EDIT BUTTON – ONLY FOR DRAFT POs */}
                      {r.status_code === "DRAFT" && (
                        <button
                          className="btn btn-sm btn-link text-primary"
                          onClick={() => {
                            setSelectedPO(r.id);
                            setShowEdit(true);
                          }}
                        >
                          Edit
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
          <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap">

            <div>
              Showing{" "}
              {(currentPage - 1) * pageSize + 1}
              {" - "}
              {Math.min(
                currentPage * pageSize,
                filtered.length
              )}
              {" of "}
              {filtered.length}
              {" records"}
            </div>

            <div className="d-flex align-items-center gap-2">

              <span>Rows:</span>

              <select
                className="form-select form-select-sm"
                style={{ width: "90px" }}
                value={pageSize}
                onChange={(e) => {
                  setPageSize(Number(e.target.value));
                  setCurrentPage(1);
                }}
              >
                <option value={20}>20</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>

              <button
                className="btn btn-sm btn-outline-secondary"
                disabled={currentPage === 1}
                onClick={() => setCurrentPage(1)}
              >
                {"<<"}
              </button>

              <button
                className="btn btn-sm btn-outline-secondary"
                disabled={currentPage === 1}
                onClick={() =>
                  setCurrentPage(currentPage - 1)
                }
              >
                {"<"}
              </button>

              {pageNumbers.map((page) => (
                <button
                  key={page}
                  className={
                    page === currentPage
                      ? "btn btn-sm btn-primary"
                      : "btn btn-sm btn-outline-secondary"
                  }
                  onClick={() =>
                    setCurrentPage(page)
                  }
                >
                  {page}
                </button>
              ))}

              <button
                className="btn btn-sm btn-outline-secondary"
                disabled={currentPage === totalPages}
                onClick={() =>
                  setCurrentPage(currentPage + 1)
                }
              >
                {">"}
              </button>

              <button
                className="btn btn-sm btn-outline-secondary"
                disabled={currentPage === totalPages}
                onClick={() =>
                  setCurrentPage(totalPages)
                }
              >
                {">>"}
              </button>

            </div>

          </div>
        </div>
      </div>

      {showView && (
        <POViewDrawer
          poId={selectedPO}
          onClose={() => setShowView(false)}
        />
      )}

      {showCreate && (
        <POCreateDrawer
          onClose={() => {
            setShowCreate(false);
            loadData();
          }}
        />
      )}

      {showFromRFQ && (
        <POFromRFQDrawer
          onClose={() => {
            setShowFromRFQ(false);
            loadData();
          }}
          onPOCreated={(poId) => {

            setShowFromRFQ(false);

            setSelectedPO(poId);

            setShowEdit(true);

            loadData();
          }}
        />
      )}

      {/* NEW EDIT DRAWER (ADDED WITHOUT CHANGING ANY EXISTING LOGIC) */}
      {showEdit && (
        <POCreateDrawer
          poId={selectedPO}
          onClose={() => {
            setShowEdit(false);
            loadData();
          }}
        />
      )}

    </div>
  );
};

export default POList;
